import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../ActionTypes";

import {
  fetchMinistriesSuccess,
  fetchMinistriesFailure,
  saveMinistrySuccess,
  saveMinistryFailure,
  deleteMinistrySuccess,
  deleteMinistryFailure,
  updateMinistrySuccess,
  updateMinistryFailure,
  fetchMinistryByIdSuccess,
  fetchMinistryByIdFailure,
} from "./action.js";

import {
  fetchMinistries,
  saveMinistry,
  deleteMinistry,
  updateMinistry,
  fetchMinistryById,
} from "./ministry.js";

// 🔹 Fetch Ministries
// function* fetchMinistriesSaga(action) {
//   try {
//     const payloadFromAction = action.payload || {};
//     const callback = action.callback || payloadFromAction?.callback;

//     // ✅ Directly send payload to API
//     const data = yield call(fetchMinistries, payloadFromAction);

//     yield put(fetchMinistriesSuccess(data?.data || []));

//     if (typeof callback === "function") {
//       callback({
//         type: 1,
//         data: data?.data,
//         totalRecords: data?.totalRecords,
//       });
//     }
//   } catch (error) {
//     yield put(fetchMinistriesFailure(error.message));
//     const callback = action.callback || action.payload?.callback;
//     if (typeof callback === "function") {
//       callback({ type: 0, error: error.message });
//     }
//   }
// }
function* fetchMinistriesSaga(action) {
    try {
      const { apiPayloadRequest } = action.payload || {};
      const callback = action.payload?.callback || action.callback;


      const data = yield call(fetchMinistries, apiPayloadRequest || {});

      yield put(fetchMinistriesSuccess(data?.data || []));

      if (typeof callback === "function") {
        callback({
          type: 1,
          data: data?.data,
          totalRecords: data?.totalRecords,
        });
      }
    } catch (error) {
      yield put(fetchMinistriesFailure(error.message));
      const callback = action.payload?.callback || action.callback;
      if (typeof callback === "function") {
        callback({ type: 0, error: error.message });
      }
    }
  }

// 🔹 Save Ministry
function* saveMinistrySaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
        const data = yield call(saveMinistry, apiPayloadRequest);

    yield put(saveMinistrySuccess(data?.data || []));

    if (typeof action.callback === "function") {
      action.callback({ type: 1, data: data?.data });
    }
  } catch (error) {
    yield put(saveMinistryFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

// 🔹 Delete Ministry
function* deleteMinistrySaga(action) {
  try {
    const { _id, callback } = action.payload;
    const data = yield call(deleteMinistry, _id);

    if (data?.type === 1) {
      yield put(deleteMinistrySuccess({ _id }));
      if (callback) callback(data);
    } else {
      yield put(deleteMinistryFailure(data?.error || "Delete failed"));
      if (callback) callback(data);
    }
  } catch (error) {
    yield put(deleteMinistryFailure(error.message));
    if (action.payload.callback)
      action.payload.callback({ type: 0, error: error.message });
  }
}

// 🔹 Update Ministry
function* updateMinistrySaga(action) {
  try {
    const { payload, callback } = action;
    const data = yield call(updateMinistry, payload);

    yield put(updateMinistrySuccess(data?.data || payload));
    if (callback) callback({ type: 1, data: data?.data });
  } catch (error) {
    yield put(updateMinistryFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// 🔹 Fetch Ministry by ID
function* fetchMinistryByIdSaga(action) {
  try {
    const { _id, callback } = action.payload;
    const data = yield call(fetchMinistryById, _id);
    const ministry = Array.isArray(data?.data) ? data.data[0] : null;

    if (ministry) {
      yield put(fetchMinistryByIdSuccess(ministry));
      if (callback) callback({ type: 1, data: ministry });
    } else {
      throw new Error("Ministry not found");
    }
  } catch (error) {
    yield put(fetchMinistryByIdFailure(error.message));
    if (action.payload.callback)
      action.payload.callback({ type: 0, error: error.message });
  }
}

export default function* ministriesWatcherSaga() {
  yield takeLatest(actionTypes.FETCH_MINISTRIES_REQUEST, fetchMinistriesSaga);
  yield takeLatest(actionTypes.SAVE_MINISTRY_REQUEST, saveMinistrySaga);
  yield takeLatest(actionTypes.DELETE_MINISTRY_REQUEST, deleteMinistrySaga);
  yield takeLatest(actionTypes.UPDATE_MINISTRY_REQUEST, updateMinistrySaga);
  yield takeLatest(actionTypes.FETCH_MINISTRY_BY_ID_REQUEST, fetchMinistryByIdSaga);
}
